import CentumInput from 'components/MainPage/dcs/centumvp/components/Input/CentumInput';
import React from 'react';
import { tabComponents } from '../SearchCondition';

interface IArbitraryCharacter {}

function ArbitraryCharacterComponent(props: tabComponents) {
    const aribitraryCharacher = props.tempConfig.aribitraryCharacher;
    const displayEnabled = props.tempConfig.display.search;

    const SetNumber = (id: any, value: any) => {
        const updateConf = { ...props.tempConfig };
        updateConf.aribitraryCharacher.check.data[id] = value;
        props.SaveConfig(updateConf);
    };

    const SelectType = (mode: string) => {
        const updateConf = { ...props.tempConfig };
        updateConf.aribitraryCharacher.select(mode);
        props.SaveConfig(updateConf);
    };

    const check = props.tempConfig.aribitraryCharacher.check;

    return (
        <div
            style={{
                boxSizing: 'border-box',
                width: '100%',
                padding: '20px',
                fontSize: '12px',
                color: displayEnabled ? 'black' : '#808080',
                pointerEvents: displayEnabled ? 'auto' : 'none'
            }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <CentumInput
                    enable={!displayEnabled}
                    checked={aribitraryCharacher.noCheck}
                    type="radio"
                    id="noCheck"
                    onChange={() => SelectType('noCheck')}
                />
                <span>No Check</span>
            </div>
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CentumInput
                        enable={!displayEnabled}
                        checked={aribitraryCharacher.check.state}
                        type="radio"
                        id="check"
                        onChange={() => SelectType('check')}
                    />
                    <span>Check ("" is not available)</span>
                </div>
                <div style={{ display: 'grid', padding: '5px 30px' }}>
                    {check.data.map((num, index) => (
                        <div key={index} style={{ paddingBottom: '10px' }}>
                            <CentumInput
                                enable={check.state && displayEnabled}
                                value={num}
                                id={`${index}`}
                                type="text"
                                width={250}
                                height={20}
                                onChange={SetNumber}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ArbitraryCharacterComponent;
